"use client";

import { Globe as ReactGlobal } from "./Globe";

/** @deprecated use `Globe` from `@faire/slate/icons/Globe` */
export const Global = ReactGlobal;
